import React, { useEffect, useState } from "react";
import {
    Button, Col, Row, Container,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from 'react-redux';
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { setWelcomeModalOpen } from "app/store/slices/authSlice";
import getBrandName from "app/shared/utils/BrandHelper";
import { getKey } from "app/shared/utils/EncryptionUtility";
import { RootState } from "../../store";

const WelcomeModal: React.FC = () => {
    const dispatch = useDispatch();

    const appInsights = useAppInsightsContext();
    if (appInsights) {
        appInsights.trackPageView({
            name: "WelcomeModal",
        });
        const metricData = {
            average: 5,
            name: "React Component Engaged Time (seconds)",
            sampleCount: 1,
        };
        const additionalProperties = { "Component Name": 'WelcomeModal' };
        appInsights.trackMetric(metricData, additionalProperties);
    }

    const {
        welcomeModalOpen,
    } = useSelector((state: RootState) => state.auth);

    const { rewardsLogoPath } = getBrandName();
    const [isOpen, setIsOpen] = useState(false);

    const hideModal = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        setIsOpen(welcomeModalOpen);
    }, [welcomeModalOpen]);

    const welcomeContent = (
        <Container className="d-flex align-items-center flex-column gap-4 my-account">
            <img
                className="sign-up-logo headerLogoImageMobile"
                src={rewardsLogoPath}
                alt="Sign up"
            />
            <Row>
                <Col className="text-center">
                    <h3 className="font-main mb-2">Welcome!</h3>
                    <p className="signOn-subText-Light">Get ready for perks, points, and all the bagels.</p>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <Button
                        className="w-100 mt-2 mb-3 order-now-card-button"
                        variant="primary"
                        onClick={() => {
                            dispatch(setWelcomeModalOpen(false));
                        }}
                    >
                        {Number(getKey("totalItems")) >= 1 ? "Continue Checkout" : "Get Started"}
                    </Button>
                </Col>
            </Row>
        </Container>
    );

    return (
        <Modal
            style={{ zIndex: "9999" }}
            show={isOpen}
            onHide={() => {
                hideModal();
            }}
            centered
            keyboard={false}
            backdrop="static"
        >
            <Modal.Body>
                <Container className="p-4">
                    {welcomeContent}
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default WelcomeModal;
